// input validation
export const isValidZipCode = (zipCode) => {
  const zipCodeRegEx = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
  return zipCodeRegEx.test(zipCode);
};

export const validateZipCode = (value) => {
  if (!isValidZipCode(value)) return ' ';
  return null;
};

export const isValidEmail = (email) => {
  const emailRegEx = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
  return emailRegEx.test(email);
};

export const validateEmail = (value) => {
  if (!isValidEmail(value)) return ' ';
  return null;
};

export const isValidPhoneNumber = (phoneNumber) => {
  // const phoneNumberRegEx = /^[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-/\s.]?[0-9]{4}$/;
  const phoneNumberRegEx = /^\d{10}$/;
  return phoneNumberRegEx.test(phoneNumber);
};

export const validatePhoneNumber = (value) => {
  if (!isValidPhoneNumber(value)) return ' ';
  return null;
};



//////////////////
// WEBPACK FOOTER
// ./config/validation.js
// module id = jzXF
// module chunks = 1